export enum ParticipantValidationDestinations {
  none = 'none',
  managerespondents = 'managerespondents',
}
